<template>
  <div :class="['badge', isAlt ? 'badge--alt' : '', isNew ? 'badge--new' : '']">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.badge {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  background-color: $txt-color-alt;
  letter-spacing: 0.36px;
  display: inline-block;
  color: $color-primary;
  border-radius: 9999px;
  line-height: 16px;
  font-weight: 700;
  font-size: 9px;
  padding: 0 7px;

  @media #{$bigger-mobile} {
    font-size: 10px;
    padding: 0 9px;
  }

  &--alt {
    background-color: $color-primary;
    color: $txt-color-alt;
    box-shadow: none;
  }
}
</style>

<script>
export default {
  name: "Badge",
  props: {
    isAlt: Boolean,
    isNew: Boolean
  }
};
</script>
